import React from "react";
import { Navigate, useLocation } from "react-router-dom";

interface RequireDashboardAuthProps {
  children: React.ReactNode;
}

const hasDashboardLoginDetails = (): boolean => {
  const apiKey = localStorage.getItem("api_key")?.trim();
  const userId = localStorage.getItem("user_id")?.trim();
  const tenantId = localStorage.getItem("tenant_id")?.trim();

  return Boolean(apiKey && userId && tenantId);
};

const RequireDashboardAuth: React.FC<RequireDashboardAuthProps> = ({
  children,
}) => {
  const location = useLocation();

  if (!hasDashboardLoginDetails()) {
    return <Navigate to="/log-in" replace state={{ from: location.pathname }} />;
  }

  return <>{children}</>;
};

export default RequireDashboardAuth;
